import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

const LogoIntro = () => {
  const [show, setShow] = useState(() => {
    if (typeof window === "undefined") return false;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    return !sessionStorage.getItem("oph_intro");
  });

  useEffect(() => {
    if (!show) return;
    const t = setTimeout(() => {
      sessionStorage.setItem("oph_intro", "1");
      setShow(false);
    }, 2600);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="logo-intro"
          exit={{ y: "-100%" }}
          transition={{ duration: 0.9, ease: [0.76, 0, 0.24, 1] }}
          className="fixed inset-0 z-[100] bg-[#F7F5F2] flex flex-col items-center justify-center"
        >
          <motion.img
            src="/logo-horizontal.webp"
            alt="On Point Homes"
            initial={{ opacity: 0, scale: 0.92, filter: "blur(14px)" }}
            animate={{ opacity: 1, scale: 1, filter: "blur(0px)" }}
            transition={{ duration: 1.4, ease: [0.16, 1, 0.3, 1] }}
            className="w-64 md:w-96 h-auto"
          />
          <motion.div
            initial={{ scaleX: 0 }}
            animate={{ scaleX: 1 }}
            transition={{ duration: 1.6, delay: 0.5, ease: [0.76, 0, 0.24, 1] }}
            className="mt-8 h-px w-40 md:w-56 bg-[#8C6A4F] origin-left"
          />
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 1.1 }}
            className="mt-6 font-mono text-[0.62rem] tracking-[0.4em] uppercase text-[#A3A09B]"
          >
            Built With Intention
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default LogoIntro;
